<template>
<div class="row finance-reports">
  <div class="col">
    <div class="d-flex align-items-center">
      <div class="finance-reports__select d-flex align-items-baseline">
          <router-link to="/finance/reports/managers" class="finance-reports__select-item">
              <p class="h1"><i class="ico ico-mine mr-1"></i>Менеджеры</p>
          </router-link>
            <router-link to="/finance/reports/clients" class="finance-reports__select-item ml-4">
              <p class="h1"><i class="ico ico-clients mr-1"></i>Клиенты</p>
          </router-link>
          <router-link to="/finance/reports/accounts" class="finance-reports__select-item ml-4" v-if="isDirector">
              <p class="h1"><i class="ico ico-income mr-1"></i>Счета</p>
          </router-link>
          <router-link to="/finance/reports/production" class="finance-reports__select-item ml-4">
              <p class="h1"><i class="fa fa-print mr-1"></i>Производство</p>
          </router-link>
      </div>
    </div>
    <router-view></router-view>
  </div>
</div>
</template>

<script>
import roles from '../../../../helpers/userRoles'

export default {
  name: 'FinanceReports',
  computed: {
    isDirector () {
      return this.$store.getters.role === roles.director
    }
  }
}
</script>

<style lang="scss">
  .finance-reports {
    &__select-item {
      border-bottom: 3px solid #d9d9d9;
      text-decoration: none;

      &:hover{
        text-decoration: none;
      }

      .ico, .fa{
        color: #d9d9d9;
      }

      &.is-active {
        cursor: default;
        border-color: #28bd8b;

        .h1, .ico, .fa {
          color: #28bd8b;
        }
      }
    }
  }
</style>
